export default __webpack_public_path__ + "static/media/sin_comisiones_por_apertura.7263b6a4.png";